import VueRouter from "vue-router";
import Vue from "vue";
import goTo from "vuetify/es5/services/goto";

Vue.use(VueRouter);

const Home = () => import(/* webpackChunkName: "home" */ "@/views/Home");
const TemplateList = () => import("@/views/TemplateList");
const TemplateDetails = () => import("@/views/TemplateDetails");
const MyCards = () => import("@/views/MyCards");
const CreateCard = () => import("@/views/CreateCard");
const FavouritesCards = () => import("../components/cards/FavouritesCards.vue");
const DraftCards = () => import("../components/cards/DraftCards.vue");
const PurchasedCards = () => import("../components/cards/PurchasedCards.vue");
const PrivacyPolicy = () =>
  import(/* webpackChunkName: "privacy" */ "@/views/PrivacyPolicy");
const ContactUs = () =>
  import(/* webpackChunkName: "contact" */ "@/views/ContactUs");
const AboutUs = () => import(/* webpackChunkName: "about" */ "@/views/AboutUs");
const FAQ = () => import(/* webpackChunkName: "faq" */ "@/views/FAQ");
const FreeInvitePreview = () => import("@/views/FreeInvitePreview");

const routes = [
  {
    path: "",
    component: Home,
    name: "home"
  },
  {
    path: "/:category_name/dc/:category_id/",
    component: TemplateList,
    name: "categoryTemplate",
    beforeEnter: (to, _from, next) => {
      if (
        parseInt(to.params.category_id) === 4 ||
        to.params.category_name === "Customised Cards"
      )
        next({ name: "home", hash: "#customized-cards" });
      else next();
    }
  },
  {
    path: "/invitation/cards/:template_id/create-card/",
    component: CreateCard,
    name: "createCard"
  },
  {
    path: "/invitation/cards/:card_id/edit-card/",
    component: CreateCard,
    name: "editCard"
  },
  {
    path: "/invitation/cards/:card_id/preview-card/",
    component: TemplateDetails,
    name: "previewCard"
  },
  {
    path: "/invitation/cards/:card_id/download",
    component: TemplateDetails,
    name: "downloadCard"
  },
  {
    path: "/invitation/cards/:template_id/template-details/",
    component: TemplateDetails,
    name: "templatesDetails"
  },
  /* shared card url*/
  {
    path: "/card/share_template/",
    component: TemplateDetails,
    name: "sharedTemplate",
    props: route => ({
      query: route.query.id
    })
  },
  {
    path: "/card/share_card/",
    component: TemplateDetails,
    name: "sharedCard",
    props: route => ({
      query: route.query.id
    })
  },
  /* my card url */
  {
    path: "/my-cards/",
    component: MyCards,
    name: "myCards",
    children: [
      {
        path: "favourite/cards",
        component: FavouritesCards,
        name: "favouritesCards"
      },
      {
        path: "draft/cards",
        component: DraftCards,
        name: "draftCards"
      },
      {
        path: "purchased/cards",
        component: PurchasedCards,
        name: "purchasedCards"
      }
    ]
  },
  /* other*/
  {
    path: "/contact-us/",
    component: ContactUs,
    name: "contactUs"
  },
  {
    path: "/about-us/",
    component: AboutUs,
    name: "aboutUs"
  },
  {
    path: "/faq/",
    component: FAQ,
    name: "faq"
  },
  {
    path: "/privacy-policy/",
    component: PrivacyPolicy,
    name: "privacyPolicy"
  },
  {
    path: "/card/:card_table_id/invite-view/",
    name: "freeInvitePreview",
    component: FreeInvitePreview
  }
];

export default () => {
  const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior: (to, _from, savedPosition) => {
      let scrollTo = 0;

      if (to.hash) {
        scrollTo = to.hash;
      } else if (savedPosition) {
        scrollTo = savedPosition.y;
      }

      return goTo(scrollTo);
    },
    routes
  });

  return router;
};
